export default "__VITE_ASSET__DBt82JAQ__"